import { Component, effect, ElementRef, inject, InjectionToken, input, Renderer2, viewChild, DOCUMENT } from "@angular/core";
import { StorageService } from "app/commons/services/storageService.service";

export const PROS_AI_CHAT_FLOW = new InjectionToken<string>("PROS_AI_CHAT_FLOW");

@Component({
  selector: "pros-ai-button",
  template: `<div #buttonContainer class="uk-display-inline-block" style="--pwc-font-size-small: 14px"></div>`
})
export class ProsAiButton {

  private readonly _storage = inject(StorageService);
  private readonly _document = inject(DOCUMENT);
  private readonly _renderer = inject(Renderer2);
  private readonly _defaultFlow = inject(PROS_AI_CHAT_FLOW, { optional: true });
  private readonly _buttonContainer = viewChild<ElementRef<HTMLDivElement>>("buttonContainer");
  private readonly _defaultContext = {
    tenantCode: this._storage.get.currentAirline().code.toUpperCase(),
    tenantName: this._storage.get.currentAirline().name,
    jwt: `Bearer ${this._storage.get.token()}`
  };

  public readonly flowName = input<string>(this._defaultFlow);
  public readonly context = input<{ [k: string]: any }, { [k: string]: any }>(this._defaultContext, { transform: value => ({ ...this._defaultContext, ...value }) });
  public readonly label = input<string>("Ask AI");
  public readonly welcomeMessage = input<string>(`## Hello!\n\nI'm your airTRFX Control Assistant. I'm here to help you navigate airTRFX Control and get the most out of your products. How can I assist you today?`);

  public readonly suggested = input<string[]>([]);

  constructor() {
    effect(() => {
      const container = this._buttonContainer()
      container.nativeElement.innerHTML = "";
      this._initializeButton(container.nativeElement);
    })
  }

  private _initializeButton(container: HTMLDivElement): HTMLElement {
    const button: any = this._document.createElement('pwc-ai-button');
    if (!button) return null;
    button.context = this.context();
    button.flowName = this.flowName();
    button.label = this.label();
    button.welcomeMessage = this.welcomeMessage();
    button.suggestedPrompts = this.suggested();
    this._renderer.appendChild(container, button);
    return button;
  }
}
